import { Box } from '@mui/material';
import { PageTitle } from '../components/Page/PageTitle';
import AlarmLogs from '../components/AlarmLogs/AlarmLogs';
import { useTranslation } from 'react-i18next';
import { ROUTES_NS } from './i18n';

export const AlarmLogsRoute = () => {
  const { t } = useTranslation(ROUTES_NS);

  return (
    <>
      <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
        <PageTitle>{t('alarmLogs')}</PageTitle>
      </Box>
      <AlarmLogs />
    </>
  );
};
